import { useUserWithCompany } from '@app/hooks/useUserWithCompany';
import { UserRole } from '@dieterApi/user/useUserQuery';
import Chip from '@mui/material/Chip/Chip';
import { useTranslation } from 'react-i18next';

export function UserRoleChip({ role }: { role: UserRole }) {
  const { t } = useTranslation();
  const { user } = useUserWithCompany();

  // The "Kunde" label is only shown to elevated viewers (Admin/Dpo). Editors and
  // read-only users see the Editor role labelled as "Bearbeiter" instead.
  const viewerIsElevated = user?.role === UserRole.Admin || user?.role === UserRole.Dpo;

  const roleConfig = (
    {
      [UserRole.Editor]: {
        label: viewerIsElevated
          ? t('route.user-management.role.Editor-dpo', 'Kunde')
          : t('route.user-management.role.Editor-self', 'Bearbeiter'),
        color: 'secondary',
      },
      [UserRole.Admin]: {
        label: t('route.user-management.role.Admin', 'Admin'),
        color: 'primary',
      },
      [UserRole.Dpo]: {
        label: t('route.user-management.role.Dpo', 'DSB'),
        color: 'primary',
      },
      [UserRole.ReadOnly]: { label: t('route.user-management.role.ReadOnly', 'ReadOnly'), color: 'info' },
    } as const
  )[role];

  if (!roleConfig) {
    console.error('Unknown role:', role);
    return <Chip size="small" label={String(role)} color="default" sx={{ fontSize: 'small' }} />;
  }

  const { label, color } = roleConfig;

  return <Chip size="small" label={label} color={color} sx={{ fontSize: 'small' }} />;
}
